// price change
export const mdPriceChange = [
  '24, 24',
  '<path d="M8 17h2v-1h1q.425 0 .713-.288Q12 15.425 12 15v-3q0-.425-.287-.713Q11.425 11 11 11H8v-1h4V8h-2V7H8v1H7q-.425 0-.713.287Q6 8.575 6 9v3q0 .425.287.712Q6.575 13 7 13h3v1H6v2h2Zm8-.75 2-2h-4ZM14 10h4l-2-2ZM4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v12q0 .825-.587 1.413Q20.825 20 20 20Zm0-2h16V6H4v12Zm0 0V6v12Z"/>'
]
